// Null rather than "0s" below a second, and null for a card restored long after
// its run, where the gap between the message and the group says nothing useful.
export function elapsedLabel(
	startedAt: Date | undefined,
	endMs: number,
): string | null {
	if (!startedAt) return null
	const seconds = Math.round((endMs - startedAt.getTime()) / 1000)
	if (seconds < 1 || seconds > 3600) return null
	if (seconds < 60) return `${seconds}s`
	return `${Math.floor(seconds / 60)}m ${seconds % 60}s`
}
